export default {
  form: {
    font_family: {
      label: 'Skrifttype',
    },
    header: {
      label: 'Overskrift',
      placeholder: 'Overskrift',
    },
    sub_header: {
      label: 'Underoverskrift',
      placeholder: 'Underoverskrift',
    },
    qr_code_header: {
      label: 'Overskrift til UI-boks',
      placeholder: 'Overskrift til UI-boks',
    },
    qr_code_description: {
      label: 'Beskrivelse til UI-boks',
      placeholder: 'Beskrivelse til UI-boks',
    },
    footer: {
      label: 'Fodtekst',
      placeholder: 'Indtast fodtekst',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Vælg URL',
    },
    url: {
      placeholder: 'www.eksempel.dk',
    },
    primary_color: {
      label: 'Primær farve',
    },
    background_color: {
      label: 'Baggrundsfarve',
    },
    cover_image: {
      label: 'Coverbillede',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Logozoom',
    },
  },
  toasts: {
    failed_to_load_data: 'Dørklistermærket kunne ikke indlæses',
  },
};
